import styled from "@emotion/styled";
import {
  Colors,
  Grid,
  GridColumn,
  Grids,
  Heading,
  MediaQueries,
  Paragraph,
  Section,
  Spacings,
  Spans,
} from "@polestar/component-warehouse-react";

const StyledGridColumn = styled(GridColumn)`
  grid-column: span ${Grids.mobile.columns};

  ${MediaQueries.tablet} {
    grid-column: 1 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktop} {
    grid-column: 3 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktopWide} {
    grid-column: 5 / span 6;
  }
`;

const StyledDate = styled(Paragraph)`
  display: block;
  color: ${Colors.black};
  margin-bottom: ${Spacings.small};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: ${Spacings.small};
  max-width: 570px;
`;

const StyledParagraph = styled(Paragraph)`
  white-space: pre-line;
`;

interface Props {
  readonly localizedDate?: string;
  readonly headline?: string;
  readonly ingress?: string;
}

const Intro = ({ localizedDate, headline, ingress }: Props) => {
  return (
    <Section>
      <Grid>
        <StyledGridColumn span={Spans.full}>
          {localizedDate && <StyledDate as="time">{localizedDate}</StyledDate>}
          {headline && <StyledHeading level={1}>{headline}</StyledHeading>}
          {ingress && <StyledParagraph>{ingress}</StyledParagraph>}
        </StyledGridColumn>
      </Grid>
    </Section>
  );
};

export default Intro;
